import ReactDOM from "react-dom";
import React from "react";
import CmsSite from './Components/CmsSite.js';
import AppConfig from './AppConfig.js';
import EpiContext from './Spa.js';
import ComponentPreLoader, { IComponentPreloadList } from "./Loaders/ComponentPreLoader.js";
import IServiceContainer from './Core/IServiceContainer.js';
import DefaultServiceContainer from './Core/DefaultServiceContainer.js';
import ServerContextType from './ServerSideRendering/ServerContext.js';

declare let __INITIAL_DATA__ : ServerContextType;

export function InitBrowser(config: AppConfig, containerId?: string, serviceContainer?: IServiceContainer) : void
{
    try {
        if (__INITIAL_DATA__?.status === 'loading') {
            __INITIAL_DATA__.onReady = () => _doInitBrowser(config, containerId, serviceContainer);
            return;
        }
    } catch (e) {
        // Ignore on purpose
    }
    return _doInitBrowser(config, containerId, serviceContainer);
}

function _doInitBrowser(config: AppConfig, containerId?: string, serviceContainer?: IServiceContainer) : void
{
    EpiContext.init(config, serviceContainer || new DefaultServiceContainer());
    
    const container = document.getElementById(containerId ? containerId : "epi-page-container");
    if (container && container.childElementCount > 0) {
        const components : IComponentPreloadList = EpiContext.config().preLoadComponents || [];
        if (EpiContext.isDebugActive()) console.info('Hydrating existing render, Stage 1. Preloading components ...', components);
        const loader = EpiContext.componentLoader();
        ComponentPreLoader.load(components, loader).finally(() => {
            if (EpiContext.isDebugActive()) console.info('Hydrating existing render, Stage 2. Hydration ...');
            ReactDOM.hydrate(<CmsSite context={ EpiContext } />, container);
        });
    } else {
        if (EpiContext.isDebugActive()) console.info('Building new application');
        ReactDOM.render(<CmsSite context={ EpiContext } />, container);
    }
}

export default InitBrowser;